export const IOS_APP_STORE_URL = 'https://apps.apple.com/us/app/paulie-ai/id6748023497'
